var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummerHeaderNarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 831,
    height: 422,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M698.996 411.014c-3.336 0-6.549-.495-9.392-1.854l3.09-6.673c7.414 3.46 17.795.247 19.278-8.033.494-2.471.618-5.684-1.854-8.527-3.583-4.201-12.605-7.291-17.301-11.863-3.336-3.213-5.066-7.044-5.066-11.617-.371-14.829 19.031-24.839 34.972-21.873l-1.359 7.291c-11.493-2.224-26.569 4.696-26.199 14.459.124 9.392 14.83 12.111 20.638 18.907 3.337 3.955 4.449 8.651 3.337 14.583-1.854 9.886-10.381 15.2-20.144 15.2"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M660.175 411.385v-70.44h23.974v6.92h-16.683v31.018h13.347v6.921h-13.347v18.784h16.683v6.797z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M654.71 376.906v3.584c0 .371.123 6.55-2.101 13.1-1.236 4.201-3.213 7.414-5.561 10.009-3.213 3.337-7.168 5.314-11.864 5.809-.865.123-1.73.123-2.595.123-6.302 0-11.74-2.348-16.065-7.167-4.325-4.82-6.302-10.875-7.415-15.077-1.235-5.437-1.359-11.74-.494-17.919.989-6.92 3.337-12.976 6.673-17.672 4.449-6.302 10.752-10.009 18.043-10.751 11.122-1.112 18.413 4.696 18.784 4.943l-4.696 5.685c-.124-.124-5.314-4.078-13.347-3.213-5.314.494-9.515 3.089-12.728 7.538-2.719 3.831-4.573 8.898-5.438 14.582-.741 5.191-.741 10.505.494 15.2.495 2.719 2.101 7.91 5.685 11.74 3.213 3.708 7.291 5.314 12.358 4.696 2.966-.247 5.19-1.483 7.167-3.46 1.607-1.73 2.966-4.201 3.955-7.044.865-2.718 1.359-5.437 1.73-7.414h-17.672v-7.292z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M595.351 393.466v-52.521h7.291v67.597h-8.404l-16.559-45.847v48.69h-7.291v-66.98h7.291z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M539.252 411.385v-70.44h23.974v6.92h-16.683v31.018h13.346v6.921h-13.346v18.784h16.683v6.797z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M514.2 340.945v63.148h21.503v7.292h-28.794v-70.44z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M481.857 340.945v63.148h21.503v7.292h-28.794v-70.44z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M462.32 379.996c-.371 0-.618 0-.988.123l8.65 35.344-7.167 1.606-8.775-36.085c-.741.124-1.483.124-2.348.247h-10.874l-7.662 27.682-7.044-1.854 7.167-26.322c-.494 0-.988 0-1.359-.124-.371 0-.865 0-1.112-.123h-.371l.371-5.561h.37c.371.123.742.123 1.113.123h2.471l9.763-35.219 7.044.123 8.156 33.243.865-.124c.371-.123.618-.247.865-.371.124 0 .247-.123.494-.123l.248-.124.37-.123c.124 0 .248-.124.248-.124.123 0 .37-.123.37-.123l.371-.248h.247l3.46 6.426s-.123.124-.494.124c-.124.124-.247.247-.618.371l-.618.247c-.247 0-.247.123-.494.247h-.494c-.124.124-.371.124-.495.247l-.494.124c-.371 0-.741.247-1.236.371m-10.998-5.438c.37 0 .741-.123 1.112-.123l-4.572-18.908-5.438 19.525c.865 0 1.73 0 2.472-.123.988 0 2.224-.124 3.213-.124l1.606-.123h.742c.37-.124.618-.124.865-.124"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M414.149 372.705v-31.76h7.414v63.519h-7.414v-25.581h-15.2v32.502h-7.292v-66.856h7.292v28.176z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M369.664 400.139c4.202 3.089 9.639 4.202 16.313 3.213l1.112 7.168c-2.101.37-4.078.494-5.932.494-6.179 0-11.493-1.73-15.942-5.067-6.178-4.572-10.257-12.358-11.369-21.75-1.112-9.762 2.225-22.12 8.898-30.276 5.932-7.662 14.088-12.111 23.356-12.976l.742 7.167c-9.269.989-15.077 6.179-18.414 10.381-2.718 3.337-4.819 7.415-6.055 11.616-1.236 4.202-1.606 9.516-1.236 13.223.495 4.326 2.348 12.235 8.527 16.807"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M327.058 376.906v3.584c0 .371.123 6.55-2.101 13.1-1.236 4.201-3.213 7.414-5.561 10.009-3.213 3.337-7.168 5.314-11.864 5.809-.865.123-1.73.123-2.595.123-6.302 0-11.74-2.348-16.065-7.167-4.325-4.82-6.302-10.875-7.415-15.077-1.235-5.437-1.359-11.74-.494-17.919.989-6.92 3.337-12.976 6.673-17.672 4.449-6.302 10.752-10.009 18.043-10.751 11.122-1.112 18.413 4.696 18.784 4.943l-4.696 5.685c-.124-.124-5.314-4.078-13.347-3.213-5.314.494-9.515 3.089-12.728 7.538-2.719 3.831-4.573 8.898-5.438 14.582-.741 5.191-.741 10.505.494 15.2.495 2.719 2.101 7.91 5.685 11.74 3.213 3.708 7.291 5.314 12.358 4.696 2.966-.247 5.19-1.483 7.167-3.46 1.607-1.73 2.966-4.201 3.955-7.044.865-2.718 1.359-5.437 1.73-7.414h-17.672v-7.292z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M267.699 393.466v-52.521h7.291v67.597h-8.404l-16.559-45.847v48.69h-7.291v-66.98h7.291z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M235.424 340.945v63.519h-7.291v-63.519z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M214.969 353.55c3.46 4.449 5.808 9.886 7.044 16.065.989 5.561.989 11.616.124 17.672-1.236 7.414-4.573 13.593-9.639 17.795-5.191 4.202-11.988 6.426-20.267 6.426-1.112 0-2.225 0-3.46-.123l.37-7.292c.989.124 1.977.124 2.843.124v-55.734c-.989-.123-1.854-.247-2.843-.247l.618-7.291c5.561.371 10.504 1.73 14.83 3.954 4.078 2.225 7.538 5.067 10.38 8.651m-.247 32.501c.865-5.19.865-10.257 0-15.077-.865-4.943-2.842-9.392-5.561-12.975-2.719-3.337-5.932-5.809-9.886-7.539v53.016c10.504-2.472 14.335-10.381 15.447-17.425"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M181.558 351.572c3.583 6.179 5.437 14.83 5.684 24.098.124 9.269-2.101 17.919-6.426 24.592-2.101 3.337-4.696 6.056-7.538 7.909-3.213 2.101-6.55 3.213-10.134 3.213h-.247c-5.684 0-10.628-2.1-14.582-5.808-3.213-3.213-5.808-7.538-7.538-12.728-1.607-4.943-2.472-10.504-2.472-16.56-.247-11.493 3.46-21.997 10.134-28.67 4.572-4.572 10.009-7.044 16.188-7.044 6.674 0 12.852 3.831 16.931 10.998m-6.921 44.736c3.584-5.561 5.314-12.729 5.314-20.514-.124-8.156-1.854-15.447-4.82-20.514-1.853-3.337-5.313-7.291-10.504-7.291-4.078 0-7.785 1.606-10.998 4.819-5.067 5.067-8.033 13.717-7.909 23.357 0 10.627 2.966 19.278 7.785 24.097 2.595 2.596 5.808 3.955 9.516 3.831 4.325-.123 8.527-2.842 11.616-7.785"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122.749 400.139c4.201 3.089 9.639 4.202 16.312 3.213l1.112 7.168c-2.101.37-4.078.494-5.932.494-6.178 0-11.492-1.73-15.941-5.067-6.179-4.572-10.257-12.358-11.369-21.75-1.113-9.762 2.224-22.12 8.897-30.276 5.932-7.662 14.088-12.111 23.357-12.976l.741 7.167c-9.268.989-15.076 6.179-18.413 10.381-2.719 3.337-4.82 7.415-6.055 11.616-1.236 4.202-1.607 9.516-1.236 13.223.494 4.326 2.348 12.235 8.527 16.807"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M727.068 209.128c-3.625 3.295-7.579 6.591-12.193 8.898L762 293.161l-16.477 10.216-49.432-78.431c-4.943.989-10.215 1.648-15.488 1.648v61.624h-20.102V120.481l-6.591.659-3.295-19.113c24.056-4.284 49.101 1.318 67.885 15.818 14.83 11.534 24.386 27.352 25.375 43.829.659 8.568.33 30.647-16.807 47.454m-46.465-87.658v85.351q21.255-.494 32.625-11.863c11.863-11.205 11.534-27.352 11.204-31.966-.989-10.875-7.25-21.42-17.795-29.659-7.909-5.932-16.477-9.886-26.034-11.863"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M574.719 288.218V100.379h63.932v18.454h-44.489v82.715h35.591v18.455h-35.591v50.09h44.489v18.125z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M555.318 100.379v170.373h-19.443V159.367L503.25 271.082h-15.818l-32.295-111.386v128.522h-19.443V100.379h19.443v.329h.329l39.875 138.408 40.204-138.737z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M416.292 100.379v170.373h-19.443V159.367l-32.625 111.715h-15.818l-32.295-111.386v128.522h-19.443V100.379h19.443v.329h.329l39.875 138.408 40.204-138.737z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M257.452 100.049h19.773l.329 90.954c0 50.091-10.216 97.215-50.09 97.215h-.33c-40.534 0-51.738-46.795-53.056-91.283-.33-20.102-.989-84.693-.989-87.658h19.443c0 .659.659 67.226 1.318 86.999.989 33.284 7.58 72.17 33.614 72.17 24.386 0 30.647-37.239 30.318-77.443z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.002 287.23c-8.897 0-17.465-1.319-25.045-4.944l8.239-17.795c19.772 9.227 47.454.659 51.408-21.42 1.318-6.591 1.648-15.159-4.943-22.739-9.557-11.204-33.613-19.443-46.136-31.636-8.898-8.568-13.511-18.784-13.511-30.977-.989-39.545 50.75-66.238 93.261-58.329l-3.625 19.443c-30.648-5.932-70.852 12.523-69.863 38.557.33 25.045 39.545 32.295 55.033 50.42 8.898 10.545 11.864 23.068 8.898 38.886-4.943 26.363-27.682 40.534-53.716 40.534"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#15b2d3",
    d: "M413.848-8.254a.837.837 0 0 1-.521 1.041l-.017.006c-1.583.524-3.164 1.04-4.741 1.561-1.556.515-3.145 1.03-4.741 1.55-.136 9.701-.398 19.353-.765 29.057-.414 10.791-.95 21.655-1.646 32.444-.016.114-.16.162-.234.068a1332 1332 0 0 1-18.925-26.374 1300 1300 0 0 1-16.37-24.042l-3.109.837-8.14 2.051c-3.219.846-6.505 1.614-9.713 2.362-.92 9.621-1.932 19.29-3.077 28.935a1368 1368 0 0 1-4.221 32.19c-.021.124-.166.156-.233.052-2.852-4.589-5.685-9.23-8.485-13.871a1375 1375 0 0 1-8.299-13.95c-2.727-4.659-5.425-9.31-8.092-13.99q-3.193-5.625-6.322-11.26c-.47.09-.946.175-1.418.26-2.756.498-5.608 1.012-8.421 1.498l-11.473 1.859a1352 1352 0 0 1-2.29 12.664 1376 1376 0 0 1-6.322 31.808 1421 1421 0 0 1-3.468 15.859c-.031.112-.182.131-.234.026-2.495-4.82-4.947-9.644-7.375-14.473l-3.606-7.251-3.571-7.298a1367 1367 0 0 1-12.397-26.296c-2.376.25-4.759.467-7.083.683-.955.085-1.912.175-2.867.26l-4.987.459-6.601.501a1182 1182 0 0 1-3.269 12.478l-2.115 7.823-2.175 7.783a1346 1346 0 0 1-9.187 31.169.12.12 0 0 1-.228.013 1387 1387 0 0 1-12.247-30.1l-2.933-7.53-2.892-7.571c-1.52-4.03-3.013-8.064-4.492-12.092l-6.604.162-5.018.041c-.968.004-1.929.01-2.896.017-2.33.027-4.71.042-7.097.029a1422 1422 0 0 1-9.724 27.4l-2.821 7.618-2.869 7.575a1323 1323 0 0 1-5.897 15.137c-.044.11-.198.108-.232-.008-1.713-5.14-3.389-10.29-5.034-15.428a1302 1302 0 0 1-4.832-15.514 1401 1401 0 0 1-4.627-15.505 1304 1304 0 0 1-3.536-12.376l-11.596-.712c-2.846-.203-5.739-.43-8.531-.653q-.719-.057-1.438-.115a1220 1220 0 0 1-5.17 11.83 1295.624 1295.624 0 0 1-13.528 29.433c-2.32 4.896-4.683 9.806-7.065 14.651-.052.108-.203.094-.234-.026a1358 1358 0 0 1-7.41-31.61 1299 1299 0 0 1-5.941-28.483c-3.258-.425-6.61-.873-9.903-1.38l-8.283-1.234-2.287-.381c-4.567 8.614-9.23 17.21-14.02 25.784A1336 1336 0 0 1 11.75 77.322c-.07.1-.219.07-.24-.043a1230 1230 0 0 1-4.868-32.123 1184 1184 0 0 1-3.682-29.044c-1.883-.411-3.76-.82-5.592-1.227-1.639-.367-3.273-.723-4.909-1.083a.835.835 0 0 1-.637-1 .846.846 0 0 1 .997-.636q2.454.54 4.91 1.09c1.653.365 3.34.733 5.03 1.107-.05-.431-.104-.858-.149-1.284-.053-.48.35-.89.78-.795 3.268.754 6.56 1.373 9.85 2.05 3.291.667 6.57 1.354 9.878 1.934l9.892 1.817 9.935 1.649c.432.068.657.6.433 1.027q-.287.546-.584 1.097l1.723.288 8.278 1.22c3.094.491 6.232.906 9.31 1.312-.099-.493-.193-.984-.292-1.477-.092-.474.276-.906.718-.852 13.294 1.82 26.662 3.192 40.04 4.287.442.032.711.54.517.979-.197.459-.401.923-.598 1.382q.437.03.876.066c2.782.222 5.668.452 8.508.65l11.009.671-.409-1.447c-.128-.46.209-.927.645-.901 13.41.683 26.842 1.088 40.274 1.134.439.003.749.49.591.945-.159.472-.321.937-.481 1.41 2.188.004 4.374-.01 6.513-.03q1.45-.012 2.89-.022l5.007-.041 6.024-.15c-.171-.463-.347-.933-.513-1.402-.167-.454.125-.943.57-.954 6.714-.118 13.42-.458 20.132-.718 6.705-.408 13.414-.738 20.111-1.296.442-.032.783.428.663.893-.12.488-.252.976-.375 1.454l6.023-.452 4.969-.455q1.431-.131 2.868-.265c2.139-.2 4.32-.398 6.497-.626l-.623-1.353c-.201-.435.06-.946.492-.997 13.366-1.384 26.69-3.123 39.961-5.14.439-.072.818.356.739.833-.091.497-.181.985-.268 1.48l10.895-1.767c2.802-.474 5.645-.993 8.398-1.49.288-.054.575-.099.859-.154-.244-.438-.489-.88-.731-1.31-.232-.425-.019-.957.418-1.036 13.206-2.424 26.367-5.113 39.42-8.25.43-.096.841.305.797.785-.051.494-.102.999-.149 1.49 3.027-.706 6.107-1.435 9.131-2.224l8.131-2.048 2.553-.693q-.415-.619-.831-1.242c-.26-.407-.092-.953.336-1.066l9.713-2.635 9.67-2.79c3.226-.907 6.427-1.919 9.632-2.91 3.204-1 6.422-1.943 9.597-3.017.423-.138.863.228.852.707-.002.506-.013 1.005-.017 1.504 1.402-.453 2.809-.922 4.19-1.371 1.579-.523 3.164-1.04 4.744-1.563a.84.84 0 0 1 1.056.542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7c1b",
    d: "m150.85 33.076-1.636-.042c-1.109-.025-2.219-.05-3.326-.087l-8.512-.228-2.877-.13-6.749-.291a.85.85 0 0 1-.799-.876.84.84 0 0 1 .876-.799l9.294.407.309.014 8.534.237 3.273.086 1.641.044 3.056.024 4.625.044c.462.014.83.39.83.846a.85.85 0 0 1-.561.778 1 1 0 0 1-.289.053l-4.668-.051zm12.549-3.908c-13.433-.046-26.864-.452-40.274-1.135-.436-.026-.773.441-.645.901l.409 1.448q.235.858.475 1.708c1.16 4.134 2.335 8.254 3.536 12.377a1401 1401 0 0 0 4.627 15.504c1.577 5.17 3.186 10.354 4.832 15.514a1373 1373 0 0 0 5.034 15.429c.034.115.188.117.232.008 2.004-5.046 3.964-10.09 5.897-15.138l2.869-7.574 2.821-7.618a1422 1422 0 0 0 9.724-27.4c.19-.558.385-1.11.573-1.67.16-.472.321-.937.481-1.41.158-.455-.152-.941-.591-.944m231.802-30.55c-1.177.369-2.361.738-3.568 1.106l-2.993.924-1.094.314-11.759 3.408-.086.023-5.582 1.51-.007.002a.83.83 0 0 1-1.016-.589c-.122-.44.14-.9.587-1.023l5.569-1.505.08-.028 11.741-3.395 1.085-.322 3.26-1.003 3.168-.977 2.933-.91 1.641-.507.007-.002a.833.833 0 0 1 1.038.555.834.834 0 0 1-.52 1.033l-.033.012-1.647.513zm7.827-6.693c-3.175 1.073-6.393 2.016-9.597 3.017-3.205.99-6.406 2.002-9.632 2.91l-9.67 2.79-9.713 2.634c-.428.114-.596.66-.336 1.066l.83 1.243c.326.488.651.976.983 1.47q8.016 12.063 16.37 24.042a1332 1332 0 0 0 18.925 26.373c.074.094.218.047.234-.067.696-10.79 1.232-21.653 1.646-32.445.367-9.703.629-19.355.765-29.056.008-.583.021-1.175.03-1.766.004-.5.015-.998.017-1.504.011-.48-.429-.845-.852-.707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff598f",
    d: "M341.279 12.304a.835.835 0 0 1-.536.978c-.023.008-.055.012-.089.024-.754.176-1.512.36-2.269.53l-1.47.345-2.774.596-4.69 1.015-5.708 1.229-5.746 1.14-4.576.904-2.899.572a1 1 0 0 1-.105.011.83.83 0 0 1-.875-.669.833.833 0 0 1 .661-.982l2.909-.575 4.404-.87 5.889-1.16 6.068-1.311 4.301-.93 2.773-.6 1.454-.336 2.276-.532.014-.005a.83.83 0 0 1 .988.626m3.164-4.028c-13.052 3.137-26.214 5.827-39.42 8.251-.436.079-.65.61-.418 1.035.242.431.487.873.732 1.31.286.518.571 1.028.86 1.54 2.088 3.758 4.192 7.51 6.322 11.26 2.667 4.68 5.365 9.332 8.093 13.991 2.734 4.658 5.498 9.304 8.298 13.95 2.8 4.64 5.633 9.282 8.485 13.871.067.104.213.071.233-.052a1368 1368 0 0 0 4.221-32.19 1281 1281 0 0 0 3.078-28.935c.055-.578.116-1.168.164-1.755.048-.492.098-.997.149-1.49.045-.48-.367-.882-.797-.786M98.321 29.522a.83.83 0 0 1-.552.708.8.8 0 0 1-.255.041c-.037.002-.069.006-.104.003l-2.961-.286-4.527-.435-5.908-.562-5.51-.62-5.122-.585-2.761-.315-1.48-.19c-.786-.098-1.565-.205-2.35-.307a.837.837 0 0 1 .205-1.66c.01.004.016.002.016.002l2.314.308 1.501.19 2.845.327 3.618.407 6.893.785 6.11.58 4.334.413 2.946.284a.833.833 0 0 1 .748.912m4.252-2.886c-13.379-1.095-26.746-2.467-40.04-4.288-.442-.054-.81.38-.718.852l.291 1.477c.113.575.233 1.15.34 1.73 1.872 9.48 3.846 18.996 5.942 28.484a1358 1358 0 0 0 7.41 31.61c.03.12.181.134.233.026 2.382-4.846 4.745-9.756 7.065-14.65a1300 1300 0 0 0 13.528-29.434c1.747-3.937 3.466-7.878 5.171-11.83l.696-1.616.599-1.383c.193-.439-.076-.947-.517-.979"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "M37.706 21.856a.82.82 0 0 1-.546.65.9.9 0 0 1-.408.042l-.007.003-5.691-.946-.089-.018-12.04-2.225-1.115-.202-10.327-2.095-.991-.198a.836.836 0 0 1 .336-1.639l11.303 2.291 1.099.208 12.028 2.215.086.01 5.68.943a.84.84 0 0 1 .682.961m5.24-2.123-9.934-1.649-9.893-1.817c-3.308-.58-6.587-1.266-9.878-1.934-3.29-.676-6.582-1.295-9.85-2.05-.43-.095-.833.316-.78.796.045.425.098.852.15 1.284l.2 1.749a1184 1184 0 0 0 3.682 29.043 1231 1231 0 0 0 4.868 32.123c.021.113.17.143.24.043a1336 1336 0 0 0 16.202-28.125c4.79-8.573 9.453-17.17 14.02-25.784q.412-.774.822-1.555c.197-.365.393-.734.584-1.097.224-.427 0-.958-.433-1.027m238.299 3.987a.84.84 0 0 1-.544.91.8.8 0 0 1-.159.038l-3.361.483-6.158.897-8.554 1.089c-1.064.138-2.139.274-3.207.41l-1.617.203-2.994.324-4.663.516a.84.84 0 0 1-.928-.74.836.836 0 0 1 .744-.918l4.618-.507 3.035-.335 1.627-.206 3.089-.396 8.619-1.096 9.505-1.375a.83.83 0 0 1 .948.703m3.468-3.75c-13.271 2.017-26.595 3.757-39.961 5.14-.432.051-.693.563-.492.997l.623 1.353c.245.536.494 1.073.739 1.608 4.029 8.78 8.153 17.543 12.397 26.296l3.571 7.298 3.606 7.252c2.428 4.829 4.88 9.652 7.375 14.472.052.106.203.086.234-.026a1421 1421 0 0 0 3.468-15.858 1376.185 1376.185 0 0 0 6.322-31.808 1353 1353 0 0 0 2.29-12.665c.098-.581.199-1.156.299-1.745.087-.495.177-.984.268-1.48.079-.477-.3-.906-.739-.833"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d355a",
    d: "m37.023 20.895-5.679-.943-.086-.01-12.028-2.215-1.1-.208-11.302-2.29a.836.836 0 0 0-.985.658.833.833 0 0 0 .649.98l.99.198L17.81 19.16l1.116.202 12.04 2.225.088.018 5.691.945.007-.002a.9.9 0 0 0 .408-.042.82.82 0 0 0 .546-.65.84.84 0 0 0-.683-.961m60.55 7.715-2.946-.284-4.335-.412-6.11-.582-6.893-.784-3.618-.407-2.845-.327-1.5-.19-2.315-.308q0 .002-.015-.002a.837.837 0 0 0-.205 1.66l2.35.306 1.479.19 2.762.316 5.122.584 5.51.62 5.549.532q.101.015.194.021c.056 0 .109.01.165.01l4.526.435 2.962.286c.035.002.067-.001.104-.003a.8.8 0 0 0 .255-.041.83.83 0 0 0 .552-.708.834.834 0 0 0-.748-.912m60.981 2.871-4.625-.044-3.056-.024-1.641-.044a435 435 0 0 1-3.273-.086l-8.534-.236-.309-.015-9.294-.407a.84.84 0 0 0-.876.799.85.85 0 0 0 .799.876l6.749.292 2.559.11.002.006.316.013 8.512.228 3.326.087 1.636.041 3.021.03 4.668.051a1 1 0 0 0 .289-.053.85.85 0 0 0 .561-.778.85.85 0 0 0-.83-.846m61.038-1.847-.007.002-.379.029-1.521.116-.511.027-9.047.528-3.873.23-3.474.142-9.459.392-.51.019-1.544.038-.378.01a.84.84 0 0 0-.816.853c.013.46.395.823.856.814l.253-.006c.038.001.079.002.112.001l.007-.002 1.563-.038.536-.02 9.345-.386 3.59-.15 3.59-.204 9.359-.549.508-.037 1.54-.112.383-.03a1 1 0 0 0 .211-.048.834.834 0 0 0-.334-1.62m60.705-6.617-9.505 1.375-8.619 1.096-3.089.396-1.627.206-3.035.335-4.618.507a.836.836 0 0 0-.744.918.84.84 0 0 0 .928.74l4.663-.516 2.994-.324 1.617-.203 3.207-.41 8.554-1.09 6.158-.896 3.361-.483a.8.8 0 0 0 .159-.037.84.84 0 0 0 .544-.911.83.83 0 0 0-.948-.703m59.993-11.339-.013.005-2.276.532-1.455.336-2.773.599-4.3.93-6.069 1.311-5.889 1.16-4.404.87-2.909.576a.834.834 0 1 0 .32 1.64l2.899-.572 4.575-.904 5.747-1.14 5.708-1.229 4.689-1.015 2.775-.596 1.469-.345 2.27-.53c.033-.012.066-.016.089-.024.4-.14.634-.56.535-.979a.83.83 0 0 0-.988-.625m58.872-16.032-.007.002-1.641.507-2.933.91c-1.052.322-2.104.651-3.168.977l-3.26 1.003-1.085.322-11.741 3.395-.08.028-5.57 1.505a.835.835 0 0 0-.586 1.023.83.83 0 0 0 1.016.59l.007-.003 5.582-1.51.086-.023L387.541.964l1.094-.314 2.993-.924 3.568-1.107L398-2.24l1.647-.513.033-.012a.834.834 0 0 0 .52-1.033.833.833 0 0 0-1.038-.555m-354.644 26.5-1.723-.289q-.41.781-.823 1.555l2.288.382 8.283 1.234c3.294.506 6.645.954 9.903 1.38-.107-.58-.227-1.156-.34-1.73-3.078-.406-6.216-.821-9.31-1.312zm133.395 9.285-5.006.042q-1.44.009-2.891.022a591 591 0 0 1-6.512.029c-.188.56-.383 1.112-.573 1.67 2.386.012 4.766-.002 7.097-.03.967-.007 1.928-.012 2.896-.016l5.018-.042 6.604-.162-.608-1.662zM362.353 6.28l-8.131 2.048c-3.024.788-6.104 1.517-9.131 2.224-.048.586-.11 1.177-.165 1.754 3.208-.748 6.494-1.516 9.712-2.361l8.141-2.052 3.109-.836c-.332-.494-.657-.982-.983-1.47zM103.367 29.063q-.44-.036-.877-.066l-.696 1.616c.478.037.96.077 1.437.115 2.793.222 5.685.45 8.532.653l11.596.711c-.16-.569-.318-1.135-.475-1.708l-11.009-.672c-2.84-.197-5.726-.427-8.508-.65m309.425-37.86c-1.58.524-3.165 1.04-4.744 1.563-1.381.45-2.788.919-4.19 1.372-.009.59-.022 1.183-.03 1.766 1.595-.52 3.185-1.036 4.741-1.55 1.576-.522 3.158-1.038 4.741-1.562l.017-.006a.835.835 0 0 0-.535-1.582M304.476 19.027c-2.752.498-5.595 1.016-8.397 1.49l-10.895 1.768c-.1.589-.201 1.164-.299 1.745l11.473-1.859a1043 1043 0 0 0 9.839-1.758c-.289-.512-.574-1.022-.861-1.54-.284.056-.571.1-.86.154M-7.18 12.166a.846.846 0 0 0-.997.635c-.1.459.187.904.637 1 1.636.36 3.27.717 4.908 1.083 1.832.407 3.71.816 5.593 1.228-.068-.586-.134-1.166-.2-1.75-1.69-.374-3.378-.742-5.03-1.107q-2.458-.55-4.911-1.09m245.566 15.92q-1.437.134-2.868.266l-4.97.455-6.022.452c-.144.57-.297 1.145-.442 1.713l6.601-.502 4.987-.458c.955-.085 1.912-.175 2.866-.26 2.324-.216 4.708-.434 7.084-.683-.245-.536-.494-1.073-.739-1.609-2.178.228-4.358.427-6.497.627"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15b2d3",
    d: "M837.246 22.644a.836.836 0 0 1-.69.954c-1.643.279-3.285.55-4.922.828-1.616.274-3.265.543-4.92.817a1219 1219 0 0 1-5.143 28.608 1247 1247 0 0 1-6.524 31.824c-.033.11-.183.135-.242.032-5.044-9.63-9.949-19.24-14.727-28.928q-6.449-13.103-12.554-26.238l-3.199.358-8.357.8c-3.309.35-6.674.613-9.957.868a1286 1286 0 0 1-7.41 28.139 1367 1367 0 0 1-9.032 31.185c-.038.118-.187.128-.237.016a1205 1205 0 0 1-6.294-14.994 1376 1376 0 0 1-6.099-15.041 1404 1404 0 0 1-5.888-15.053 1402 1402 0 0 1-4.55-12.085c-.478.018-.961.03-1.44.042-2.8.078-5.697.156-8.551.211l-11.622.106c-1.375 4.07-2.762 8.118-4.175 12.174a1379 1379 0 0 1-5.426 15.25 1244 1244 0 0 1-5.625 15.239 1430 1430 0 0 1-5.822 15.153c-.048.106-.199.103-.235-.01a1371 1371 0 0 1-5.106-15.42l-2.471-7.712-2.428-7.753a1365 1365 0 0 1-8.286-27.866c-2.387-.112-4.776-.256-7.106-.394-.956-.06-1.916-.115-2.872-.175l-5-.3-6.6-.5a1225 1225 0 0 1-5.115 11.842l-3.272 7.413-3.325 7.365a1339 1339 0 0 1-13.786 29.426.12.12 0 0 1-.227-.022 1386 1386 0 0 1-7.564-31.603l-1.763-7.887-1.716-7.92c-.895-4.213-1.761-8.427-2.615-12.632l-6.553-.837-4.967-.716c-.958-.142-1.908-.282-2.865-.42-2.308-.326-4.663-.67-7.02-1.043a1419 1419 0 0 1-13.749 25.619l-3.938 7.104-3.98 7.055a1305 1305 0 0 1-8.114 14.074c-.06.101-.212.076-.228-.043-.917-5.34-1.797-10.684-2.647-16.011a1294 1294 0 0 1-2.436-16.066q-1.164-8.024-2.233-16.025c-.566-4.257-1.105-8.508-1.628-12.769l-11.356-2.453a1077 1077 0 0 1-8.335-1.933l-1.403-.331c-2.282 3.649-4.576 7.286-6.898 10.914a1302.276 1302.276 0 0 1-17.815 27.054 1140 1140 0 0 1-9.195 13.417c-.067.099-.215.062-.227-.062a1359 1359 0 0 1-2.554-32.366c-.639-9.695-1.154-19.4-1.574-29.054-3.156-.911-6.402-1.86-9.581-2.858l-8.002-2.47-2.204-.722A1324 1324 0 0 1 447.1 21.19a1331 1331 0 0 1-20.261 25.357c-.084.088-.227.036-.23-.078-.139-10.811-.111-21.69.036-32.49.131-9.78.371-19.505.743-29.267-1.798-.69-3.593-1.379-5.343-2.057-1.564-.61-3.126-1.209-4.688-1.812a.835.835 0 0 1-.479-1.084.846.846 0 0 1 1.081-.478q2.344.903 4.69 1.818c1.579.61 3.191 1.229 4.805 1.854.015-.434.027-.864.047-1.292.02-.482.479-.828.89-.668 3.118 1.239 6.279 2.348 9.429 3.512 3.152 1.157 6.289 2.332 9.472 3.404l9.505 3.29 9.572 3.129c.417.133.558.692.273 1.08-.243.33-.493.665-.743.996l1.66.545 7.999 2.457c2.984.952 6.023 1.835 9.005 2.701-.023-.502-.042-1.002-.065-1.504-.02-.482.409-.854.838-.734 12.867 3.806 25.874 7.18 38.934 10.281.432.098.621.641.364 1.046l-.801 1.277q.428.096.857.197c2.716.64 5.534 1.302 8.312 1.926l10.782 2.326-.186-1.493c-.057-.474.346-.885.774-.793 13.152 2.699 26.369 5.127 39.64 7.2.434.069.667.596.442 1.023-.229.443-.459.878-.688 1.32 2.163.335 4.325.651 6.442.955.958.139 1.911.274 2.861.414l4.956.715 5.978.762c-.099-.484-.203-.975-.296-1.464-.097-.474.266-.913.708-.857 6.654.897 13.335 1.572 20.009 2.328 6.69.61 13.372 1.296 20.076 1.755.442.035.71.541.521.983-.193.464-.396.927-.59 1.38l6.022.463 4.981.3q1.435.087 2.875.171c2.145.126 4.33.258 6.517.362l-.411-1.432c-.134-.46.202-.926.636-.911 13.422.65 26.856.941 40.28.95.444-.004.755.476.604.936-.164.477-.327.946-.489 1.423l11.037-.103c2.842-.046 5.731-.13 8.527-.206.293-.009.584-.01.873-.022-.175-.47-.351-.943-.525-1.406-.165-.454.126-.948.569-.96 13.421-.403 26.837-1.075 40.214-2.207.44-.03.786.43.669.898-.124.48-.251.971-.372 1.45 3.099-.241 6.254-.497 9.363-.82l8.346-.797 2.628-.3-.634-1.354c-.195-.441.053-.955.493-1.003l10-1.139 9.98-1.297c3.327-.41 6.643-.928 9.961-1.423 3.318-.506 6.642-.952 9.942-1.534.44-.073.819.355.736.827-.078.5-.165.991-.244 1.484 1.454-.236 2.916-.488 4.349-.723 1.64-.278 3.285-.55 4.926-.829a.84.84 0 0 1 .962.695"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7c1b",
    d: "m571.023 23.804-1.611-.288a298 298 0 0 1-3.274-.587l-8.381-1.511-2.824-.562-6.628-1.307a.85.85 0 0 1-.657-.986.837.837 0 0 1 .986-.658l9.126 1.805.303.06 8.401 1.523 3.223.579 1.615.29 3.017.486 4.566.742c.454.083.761.51.692.962a.85.85 0 0 1-.672.684 1 1 0 0 1-.293.009l-4.607-.756zm12.995-1.968c-13.272-2.073-26.488-4.502-39.641-7.201-.427-.092-.831.32-.773.793l.185 1.493c.069.59.14 1.174.211 1.76a1308 1308 0 0 0 1.628 12.77q1.069 8.002 2.234 16.024c.779 5.348 1.587 10.716 2.435 16.066a1370 1370 0 0 0 2.648 16.011c.015.12.167.145.227.044 2.743-4.686 5.442-9.377 8.114-14.075l3.98-7.054 3.939-7.105c4.689-8.526 9.266-17.06 13.749-25.619.271-.522.547-1.038.818-1.564.229-.442.459-.878.688-1.32.224-.427-.009-.955-.442-1.024m233.757 4.787c-1.219.187-2.445.373-3.694.555l-3.097.461-1.13.146-12.138 1.594-.088.01-5.747.65-.007.001a.835.835 0 0 1-.181-1.659l5.733-.647.083-.016 12.119-1.583 1.121-.155 3.374-.499 3.279-.488 3.037-.456 1.699-.254.007-.001a.83.83 0 0 1 .942.705.834.834 0 0 1-.704.95l-1.705.258zm8.748-5.435c-3.301.582-6.624 1.028-9.943 1.535-3.317.495-6.634 1.012-9.96 1.422l-9.981 1.297-9.999 1.14c-.441.047-.688.561-.493 1.002q.317.68.634 1.354c.248.532.496 1.063.749 1.601q6.104 13.135 12.553 26.238a1334 1334 0 0 0 14.728 28.928c.059.104.209.079.242-.031 2.316-10.561 4.485-21.22 6.524-31.825a1219 1219 0 0 0 5.142-28.608c.096-.575.197-1.159.296-1.741.079-.494.165-.984.243-1.484.083-.473-.296-.9-.735-.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff598f",
    d: "M762.405 32.013a.833.833 0 0 1-.677.887c-.024.004-.056.003-.091.01-.772.06-1.55.128-2.324.181l-1.505.12-2.832.17-4.79.296-5.828.352-5.852.26-4.66.203-2.952.128q-.057.001-.105-.005a.834.834 0 0 1 .037-1.664l2.962-.13 4.485-.195 5.997-.259 6.197-.379 4.391-.271 2.832-.173 1.489-.113 2.33-.183.014-.003a.83.83 0 0 1 .882.768m3.736-3.504c-13.376 1.131-26.793 1.803-40.213 2.207-.444.012-.735.505-.57.96.174.463.35.936.525 1.406.206.554.41 1.101.619 1.651q2.242 6.044 4.549 12.086a1404 1404 0 0 0 5.889 15.052 1357 1357 0 0 0 6.098 15.042c2.067 5.01 4.167 10.026 6.294 14.993.05.113.199.103.238-.016a1367 1367 0 0 0 9.032-31.185 1280 1280 0 0 0 7.409-28.138c.141-.563.291-1.138.428-1.71.121-.48.247-.97.372-1.45.116-.468-.23-.927-.67-.898M519.632 12.363a.83.83 0 0 1-.652.616.8.8 0 0 1-.258.002c-.037-.004-.07-.005-.104-.012l-2.884-.73-4.409-1.113-5.756-1.448-5.352-1.445-4.976-1.35-2.682-.729-1.433-.411c-.764-.215-1.518-.44-2.278-.658a.836.836 0 0 1 .453-1.61c.009.006.016.004.016.004l2.241.654 1.455.415 2.763.752 3.515.948 6.695 1.816 5.952 1.497 4.223 1.062 2.869.726a.833.833 0 0 1 .602 1.014m4.639-2.212C511.211 7.05 498.203 3.676 485.337-.13c-.429-.12-.858.253-.839.734l.066 1.505c.024.585.056 1.172.075 1.761.419 9.654.934 19.359 1.574 29.054a1359 1359 0 0 0 2.553 32.366c.013.123.16.16.228.061 3.086-4.43 6.163-8.927 9.194-13.416a1288 1288 0 0 0 17.816-27.054c2.321-3.628 4.616-7.265 6.897-10.915q.466-.745.933-1.492c.264-.424.535-.853.8-1.276.258-.405.069-.948-.363-1.046"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "M460.869-4.364a.82.82 0 0 1-.638.56.9.9 0 0 1-.41-.02l-.007.001-5.483-1.793-.085-.031-11.566-4.017-1.073-.369-9.892-3.629-.95-.345a.833.833 0 0 1-.493-1.068.836.836 0 0 1 1.073-.501l10.827 3.97 1.055.372 11.557 4.004.083.024 5.472 1.789a.84.84 0 0 1 .53 1.053m5.5-1.308L456.797-8.8l-9.505-3.29c-3.183-1.072-6.32-2.246-9.472-3.403-3.15-1.165-6.311-2.273-9.429-3.512-.411-.16-.87.186-.89.668-.02.428-.032.858-.047 1.292l-.066 1.76c-.372 9.76-.611 19.486-.743 29.266-.147 10.8-.175 21.679-.036 32.49.003.114.146.166.23.078 6.88-8.41 13.63-16.837 20.262-25.357a1334 1334 0 0 0 18.798-24.786c.25-.331.5-.666.743-.996.286-.388.144-.947-.273-1.08m234.967 39.91a.84.84 0 0 1-.675.818.8.8 0 0 1-.163.012l-3.395-.029-6.223-.043-8.621-.215c-1.072-.023-2.155-.052-3.231-.078l-1.63-.044-3.008-.13-4.688-.195a.84.84 0 0 1-.805-.872.836.836 0 0 1 .874-.794l4.641.195 3.051.127 1.64.042 3.112.075 8.686.217 9.604.075a.83.83 0 0 1 .831.838m3.995-3.183c-13.424-.01-26.857-.302-40.28-.951-.434-.015-.77.451-.636.911l.411 1.432c.161.566.327 1.135.488 1.701a1371 1371 0 0 0 8.286 27.865l2.428 7.754 2.471 7.713c1.671 5.14 3.367 10.278 5.106 15.42.036.111.187.115.235.009a1409 1409 0 0 0 5.822-15.153c1.912-5.067 3.784-10.16 5.625-15.239 1.845-5.083 3.649-10.17 5.426-15.25 1.413-4.056 2.8-8.104 4.175-12.175.185-.56.371-1.112.559-1.68.161-.476.324-.945.488-1.422.151-.46-.16-.94-.604-.935"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d355a",
    d: "m460.339-5.417-5.472-1.789-.084-.024-11.556-4.004-1.055-.372-10.827-3.97a.835.835 0 0 0-1.073.502c-.16.429.064.911.493 1.067l.95.345 9.892 3.63 1.073.368 11.566 4.017.085.03 5.483 1.795.007-.002c.133.04.274.045.41.02a.82.82 0 0 0 .638-.56.84.84 0 0 0-.53-1.053m58.691 16.766-2.869-.726-4.223-1.062-5.952-1.496-6.696-1.816-3.515-.948-2.763-.753-1.455-.415-2.241-.653q-.002.001-.015-.005a.837.837 0 0 0-.454 1.61l2.278.658 1.433.411 2.683.729 4.975 1.35 5.353 1.445 5.405 1.363q.098.03.189.05c.056.008.106.027.161.035l4.41 1.113 2.884.73c.034.008.066.009.103.013a.8.8 0 0 0 .258-.002.83.83 0 0 0 .653-.617.834.834 0 0 0-.602-1.014m59.849 12.043-4.565-.742-3.018-.486-1.615-.29c-1.082-.19-2.153-.383-3.222-.58l-8.401-1.521-.303-.062-9.127-1.804a.84.84 0 0 0-.986.657.85.85 0 0 0 .658.986l6.628 1.308 2.512.494.002.007.309.06 8.381 1.511 3.275.588 1.611.288 2.981.485 4.608.755a1 1 0 0 0 .293-.008.85.85 0 0 0 .672-.685.85.85 0 0 0-.693-.961m60.617 7.386-.007.001-.379-.029-1.52-.114-.51-.051-9.023-.843-3.864-.357-3.455-.385-9.409-1.04-.507-.058-1.532-.195-.376-.047a.837.837 0 0 0-.935.72.84.84 0 0 0 .723.934l.251.031.111.019.007-.002 1.551.2.533.06 9.296 1.029 3.572.394 3.579.34 9.335.87.507.04 1.54.122.383.028a1 1 0 0 0 .216-.016.833.833 0 0 0-.087-1.651m61.009 2.621-9.604-.075-8.686-.217-3.112-.075-1.64-.042-3.051-.127-4.641-.195a.836.836 0 0 0-.874.794.84.84 0 0 0 .805.872l4.688.194 3.008.132 1.629.043 3.232.078 8.621.215 6.223.043 3.395.03a.8.8 0 0 0 .163-.013.84.84 0 0 0 .675-.818.83.83 0 0 0-.831-.839m61.018-2.153-.014.003-2.331.182-1.488.113-2.832.173-4.392.271-6.196.38-5.997.258-4.485.196-2.962.13a.833.833 0 0 0-.038 1.663 1 1 0 0 0 .106.006l2.952-.128 4.659-.203 5.853-.26 5.828-.353 4.789-.296 2.833-.17 1.505-.12 2.323-.181c.035-.006.068-.005.092-.01a.835.835 0 0 0-.205-1.654m60.616-6.963-.007.002-1.698.253-3.038.457c-1.087.159-2.177.326-3.279.488l-3.374.499-1.121.154-12.118 1.584-.084.016-5.733.647a.834.834 0 0 0-.734.923.83.83 0 0 0 .916.736l.007-.002 5.746-.65.088-.009 12.139-1.594 1.129-.146 3.098-.461 3.694-.556 2.902-.427 1.705-.259.035-.006a.833.833 0 0 0 .67-.943.834.834 0 0 0-.943-.706M467.559-3.05l-1.66-.545q-.523.71-1.048 1.414l2.204.722 8.002 2.47c3.179.998 6.425 1.947 9.581 2.858-.018-.59-.05-1.176-.075-1.761-2.982-.866-6.021-1.75-9.005-2.701zm130.466 29.314-4.956-.715c-.95-.14-1.903-.275-2.861-.414-2.117-.304-4.279-.62-6.442-.954-.271.525-.547 1.041-.818 1.563 2.357.374 4.712.718 7.02 1.043.957.139 1.907.279 2.865.42l4.967.717 6.553.837-.35-1.735zm186.122 2.976-8.346.797c-3.109.323-6.264.579-9.363.82-.136.573-.286 1.148-.427 1.71 3.283-.255 6.648-.519 9.957-.869l8.357-.799 3.199-.358q-.378-.806-.749-1.601zM524.69 12.67q-.43-.1-.857-.196-.466.745-.932 1.492l1.403.33c2.728.641 5.552 1.303 8.335 1.934l11.356 2.453q-.108-.877-.211-1.76l-10.782-2.326a840 840 0 0 1-8.312-1.926m311.594 9.28c-1.641.278-3.286.55-4.926.828-1.433.236-2.895.487-4.349.723-.098.583-.2 1.167-.295 1.742 1.655-.274 3.304-.543 4.92-.817 1.637-.278 3.279-.55 4.922-.828l.018-.003a.836.836 0 0 0 .672-.95.84.84 0 0 0-.962-.696M725.01 33.103c-2.796.077-5.685.16-8.527.206l-11.037.102c-.187.568-.373 1.12-.558 1.68l11.622-.105a1050 1050 0 0 0 9.991-.253q-.31-.823-.618-1.652c-.289.012-.58.013-.873.022M417.959-20.718a.845.845 0 0 0-1.081.478.835.835 0 0 0 .479 1.084c1.562.603 3.124 1.202 4.688 1.812 1.75.678 3.545 1.367 5.343 2.057l.066-1.759c-1.614-.625-3.226-1.244-4.805-1.854q-2.346-.915-4.69-1.818m240.35 52.803q-1.44-.084-2.875-.17l-4.981-.3-6.022-.463c-.228.543-.467 1.087-.695 1.627l6.6.5 5 .3c.956.06 1.916.116 2.872.175 2.33.138 4.719.282 7.106.394-.161-.566-.327-1.135-.488-1.701-2.187-.104-4.372-.236-6.517-.362"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 38.978,
    height: 74.961,
    x: 687.745,
    y: 340.053,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 27.974,
    height: 74.44,
    x: 660.175,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 50.654,
    height: 72.728,
    x: 608.057,
    y: 340.804,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 36.254,
    height: 74.44,
    x: 570.388,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 27.974,
    height: 74.44,
    x: 539.252,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 32.794,
    height: 74.44,
    x: 506.909,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 32.794,
    height: 74.44,
    x: 474.566,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 47.87,
    height: 81.237,
    x: 426.112,
    y: 339.833,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 33.906,
    height: 74.44,
    x: 391.657,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 37.453,
    height: 74.069,
    x: 353.635,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: 50.654,
    height: 72.728,
    x: 280.405,
    y: 340.804,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 36.254,
    height: 74.44,
    x: 242.736,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    width: 11.291,
    height: 67.519,
    x: 228.133,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: 38,
    height: 74.563,
    x: 188.771,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    width: 52.954,
    height: 74.811,
    x: 138.293,
    y: 340.574,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    width: 37.453,
    height: 74.069,
    x: 106.72,
    y: 340.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529 0 0 0 0 0.698039 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    width: 122.385,
    height: 214.753,
    x: 650.615,
    y: 100.624,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: 74.931,
    height: 199.839,
    x: 574.719,
    y: 100.379,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 130.624,
    height: 199.839,
    x: 435.694,
    y: 100.379,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    width: 130.624,
    height: 199.839,
    x: 296.668,
    y: 100.379,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    width: 115.465,
    height: 200.169,
    x: 173.089,
    y: 100.049,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    width: 104.275,
    height: 201.229,
    x: 68,
    y: 98,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h831v422H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummerHeaderNarrow);
export default __webpack_public_path__ + "static/media/summer_header_narrow.86f5524cc45a3e149862a3126418a1ab.svg";
export { ForwardRef as ReactComponent };